export const getLocationText = (
  roleLocaleId: string,
): {
  title: string;
  subheader: string;
  institutionPlaceholder: string;
  institutionTitle: string;
  institutionLabel: string;
  institutionAdd: string;
  institutionRemove: string;
  institutionMissingOption: string;
  institutionAddOption: string;
} => {
  switch (roleLocaleId) {
    case 'teacher':
    case 'educator':
    case 'school-administrator':
      return {
        title: 'profile-builder.location.title.teacher',
        subheader: 'profile-builder.location.subheader.teacher',
        institutionPlaceholder: 'institution-search.placeholder.teacher',
        institutionTitle: 'profile-builder.institution.title.teacher',
        institutionLabel: 'profile-builder.institution.label.teacher',
        institutionAdd: 'institution-search.add-institution.teacher',
        institutionRemove: 'institution-search.remove-institution.teacher',
        institutionMissingOption: 'profile-builder.location.option.not-seen.teacher',
        institutionAddOption: 'profile-builder.location.option.add.teacher',
      };
    case 'parent':
      return {
        title: 'profile-builder.location.title.parent',
        subheader: 'profile-builder.location.subheader.parent',
        institutionPlaceholder: 'institution-search.placeholder.parent',
        institutionTitle: 'profile-builder.institution.title.parent',
        institutionLabel: 'profile-builder.institution.label.parent',
        institutionAdd: 'institution-search.add-institution.parent',
        institutionRemove: 'institution-search.remove-institution.parent',
        institutionMissingOption: 'profile-builder.location.option.not-seen.parent',
        institutionAddOption: 'profile-builder.location.option.add.parent',
      };
    case 'district-administrator':
      return {
        title: 'profile-builder.location.title.district-administrator',
        subheader: 'profile-builder.location.subheader.district-administrator',
        institutionPlaceholder: 'institution-search.placeholder.district-administrator',
        institutionTitle: 'profile-builder.institution.title.district-administrator',
        institutionLabel: 'profile-builder.institution.label.district-administrator',
        institutionAdd: 'institution-search.add-institution.district-administrator',
        institutionRemove: 'institution-search.remove-institution.district-administrator',
        institutionMissingOption: 'profile-builder.location.option.not-seen.district-administrator',
        institutionAddOption: 'profile-builder.location.option.add.district-administrator',
      };
    case 'instructional-coach':
    case 'library-or-media-specialist':
    case 'technology-administrator':
    case 'administrator':
    case 'higher-education':
    case 'counselor':
    case 'social-worker-psychologist':
    case 'other':
    default:
      return {
        title: 'profile-builder.location.title.institution',
        subheader: 'profile-builder.location.subheader.institution',
        institutionPlaceholder: 'institution-search.placeholder.institution',
        institutionTitle: 'profile-builder.institution.title.institution',
        institutionLabel: 'profile-builder.institution.label.institution',
        institutionAdd: 'institution-search.add-institution.institution',
        institutionRemove: 'institution-search.remove-institution.institution',
        institutionMissingOption: 'profile-builder.location.option.not-seen.institution',
        institutionAddOption: 'profile-builder.location.option.add.institution',
      };
  }
};

export const SUPPORTED_COUNTRIES = ['US'];
